import { BaseComponent } from 'src/scripts/components/base-component'
import { SidebarButton } from 'src/scripts/components/sidebar'
import { Nullable } from 'src/scripts/types/common'
import { getTemplateFirstChild } from 'src/scripts/utils/dom'

export class QuoteComponent extends BaseComponent {
  sidebarButtonSelector: string
  quoteLinkAttribute: string
  quoteProductLinkAttribute: string
  quoteLinkTemplateAttribute: string
  targetAttribute: string
  quoteWithProductClass: string

  quoteLink: Nullable<HTMLAnchorElement>
  quoteProductLink: Nullable<HTMLAnchorElement>
  quoteLinkTemplate: Nullable<Element>
  sidebarButton: Nullable<SidebarButton>
  target: Nullable<HTMLElement>

  constructor() {
    super()

    this.sidebarButtonSelector = 'sidebar-button'
    this.quoteLinkAttribute = '[data-quote-link]'
    this.quoteProductLinkAttribute = '[data-quote-product-link]'
    this.quoteLinkTemplateAttribute = '[data-quote-link-template]'
    this.targetAttribute = '[data-quote-line-clamp-target]'
    this.quoteWithProductClass = 'quote--with-product-link'

    this.quoteLink = this.querySelector(this.quoteLinkAttribute)
    this.quoteProductLink = this.querySelector(this.quoteProductLinkAttribute)
    this.quoteLinkTemplate = this.querySelector(this.quoteLinkTemplateAttribute)
    this.sidebarButton = this.closest(this.sidebarButtonSelector)

    this.target = this.querySelector(this.targetAttribute)
  }

  connectedCallback(): void {
    if (this.quoteProductLink && this.target) {
      this.setLinks()
    }
  }

  setLinks = (): void => {
    const targetHeight = this.target.offsetHeight
    const targetTextHeight = (this.target.firstElementChild as HTMLElement)
      .offsetHeight
    if (targetTextHeight > targetHeight) {
      return
    }

    if (this.quoteLink) {
      this.quoteLink.href = this.quoteProductLink.href
    } else {
      const clone = getTemplateFirstChild(
        this.quoteLinkTemplate,
      ) as HTMLAnchorElement
      clone.href = this.quoteProductLink?.href

      this.appendChild(clone)
    }

    if (this.sidebarButton) {
      this.sidebarButton.destroyListeners()
    }

    this.classList.add(this.quoteWithProductClass)
  }
}
